<h2 mat-dialog-title>
   Admin Comments
  </h2>
  
  <div mat-dialog-content>
    <div class="container bgcolor" fxLayout="row" fxLayoutAlign="center center">
        <form  fxFlex="100%" fxFlex.sm="100%" fxFlex.xs="100%">
            <div fxLayout="row">
              <mat-form-field class="Full-width" appearance="outline">
                <mat-label>Comment</mat-label>
                <textarea disabled="disabled"
                  matInput
                  type="text"
               
                >{{data}}</textarea>
      
              
              </mat-form-field>
  
            </div>
           
      

        </form>
      </div>
      
  </div>
  
  <div mat-dialog-actions>
    <!-- <button mat-raised-button cdkFocusInitial (click)="onDismiss()">Cancel</button> -->
    <!-- <button mat-raised-button   [disabled]="formGroup.invalid" (click)="onConfirm()">Save</button> -->
  </div>